const { qs, build, apc, destroyinputs } = require('../../libs/qs')
const ctrlz = require('./ctrlz')
const uuid = require('uuid').v4
const createLfo = require('@azopsoft/shared/ui').lfo

module.exports = createLfo({ qs, build, apc, destroyinputs, ctrlz, uuid })
